import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ContentContainer from './ContentContainer';

class BrowserDetectContent extends React.Component {
    render() {
        const { texts } = this.props;
        return (
            <ContentContainer>
                <h1 className="browser-detect-content__headline">{texts['title']}</h1>

                <p>{texts['browserdetect.first.copy']}</p>
                <p>{texts['browserdetect.second.copy']}</p>

                <ul>
                    <li className="browser-detect-content__list-item">
                        <a
                            className="browser-detect-content__link"
                            href={texts['browserdetect.edge.href']}
                            ref={'noopener nofollow'}
                            target='_blank'
                        >
                            {texts['browserdetect.edge.copy']}
                        </a>
                    </li>
                    <li className="browser-detect-content__list-item">
                        <a
                            className="browser-detect-content__link"
                            href={texts['browserdetect.chrome.href']}
                            ref={'noopener nofollow'}
                            target='_blank'
                        >
                            {texts['browserdetect.chrome.copy']}
                        </a>
                    </li>
                    <li className="browser-detect-content__list-item">
                        <a
                            className="browser-detect-content__link"
                            href={texts['browserdetect.firefox.href']}
                            ref={'noopener nofollow'}
                            target='_blank'
                        >
                            {texts['browserdetect.firefox.copy']}
                        </a>
                    </li>
                </ul>
            </ContentContainer>
        );
    }
}

BrowserDetectContent.propTypes = {};

BrowserDetectContent.defaultProps = {};

function mapStateToProps(state) {
    return {
        texts: {
            title: state.app.texts['browserdetect.title'],
            'browserdetect.first.copy': state.app.texts['browserdetect.first.copy'],
            'browserdetect.second.copy': state.app.texts['browserdetect.second.copy'],
            'browserdetect.edge.copy': state.app.texts['browserdetect.edge.copy'],
            'browserdetect.edge.href': state.app.texts['browserdetect.edge.href'],
            'browserdetect.chrome.copy': state.app.texts['browserdetect.chrome.copy'],
            'browserdetect.chrome.href': state.app.texts['browserdetect.chrome.href'],
            'browserdetect.firefox.copy': state.app.texts['browserdetect.firefox.copy'],
            'browserdetect.firefox.href': state.app.texts['browserdetect.firefox.href'],
        },
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BrowserDetectContent);
